import styled from 'styled-components';
import { Flex, FlexCenter } from './flex';
import Input from './input';
import InputNumber from './input-number';
import InputMaxLen from './input-max-len';
import Icon from './icon';
import IconText from './icon-text';
import Button from './button';
import Link from './link';
import Dropdown from './dropdown';
import DropdownButton from './dropdown-button';
import media from './media';
import TimePicker from './time-picker';
import { SubTitle, LastValidated } from './subTitle';
import Title from './title';
import TitleActions from './title-actions';
import Label from './label';
import FormItem from './form-item';
import FormField from './form-field';
import FormText from './form-text';
import Info from './info';
import { Card, CardHeader, CardTitle, CardBody } from './card';
import { NoteTitle, NoteName, NoteText } from './note';
import Modal from './modal';
import SapId from './sap-id';
import DatePicker from './date-picker';
import BackToTop from './back-to-top';
import EmailLink from './email-link';
import ClipboardCopy from './clipboard-copy';
import ButtonGroup from './button-group';
import { StateText, StateIcon } from './state-form';
import TagsTextArea from './tags-textarea';
import RadioButtons from './radio-buttons';
import AlertText from './Text';
import InfoCard from './info-card';
import NotificationButton from './notification-buttons';
import MaxLengthInput from './max-length-input';
import ScrollBar from './scrollbar';
import Row from './row';
import Col from './col';
import RichTextEditor from './rich-text-editor';
import notification from './notification';
import RadioItem from './radio-item';
import InfoTooltip from './info-tooltip';

import {
  flexProps,
  borderProps,
  fontWeightProps,
  marginProps,
  paddingProps,
  widthProps,
  heightProps,
} from './props';

const Div = styled.div`
  ${marginProps};
  ${paddingProps};
  ${fontWeightProps};
  ${widthProps};
  ${heightProps};
  ${flexProps};
  ${borderProps};
`;

const Span = styled.span`
  font-size: 16px;
  ${marginProps};
  ${fontWeightProps};
`;
// we need to manually export the imports again
// an ECMAScript proposal is coming, currently: stage 1
export {
  Flex,
  FlexCenter,
  Input,
  InputNumber,
  InputMaxLen,
  Icon,
  Button,
  Link,
  Dropdown,
  DropdownButton,
  Div,
  Span,
  TimePicker,
  SubTitle,
  LastValidated,
  Title,
  TitleActions,
  flexProps,
  borderProps,
  fontWeightProps,
  marginProps,
  paddingProps,
  media,
  Label,
  FormItem,
  FormText,
  Info,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Modal,
  NoteTitle,
  NoteName,
  NoteText,
  SapId,
  DatePicker,
  BackToTop,
  EmailLink,
  ClipboardCopy,
  IconText,
  StateText,
  StateIcon,
  ButtonGroup,
  TagsTextArea,
  RadioButtons,
  AlertText,
  InfoCard,
  NotificationButton,
  MaxLengthInput,
  ScrollBar,
  Row,
  Col,
  FormField,
  RichTextEditor,
  notification,
  RadioItem,
  InfoTooltip,
};
